import {
  emptyFetch,
  isMtvOrUutisetService,
  Service,
} from "@tv4/avod-web-player-common";

import { Tracker } from "./tracker";

export interface IFinnpanelTrackerInstanceOptions {
  deviceId: string;
  service: Service;
}

const FINNPANEL_URL: string = "https://endpoint.finnpanel.fi/?vid=";

export class FinnpanelTracking extends Tracker {
  private deviceId: string;
  private service: Service;
  private tracked: boolean = false;

  constructor({ deviceId, service }: IFinnpanelTrackerInstanceOptions) {
    super();

    this.deviceId = deviceId;
    this.service = service;
  }

  public onStart(): void {
    this.track();
  }

  public onAdBreakStart(): void {
    this.track();
  }

  private track(): void {
    if (this.tracked) {
      return;
    }
    this.tracked = true;

    /**
     * intention is that this is called each time a video start,
     * and also should be synched with wire session starting.
     */
    if (isMtvOrUutisetService(this.service)) {
      emptyFetch(FINNPANEL_URL + this.deviceId);
    }
  }

  public destroy(): void {
    // noop
  }
}
